import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { BaseAppDetailEnvService } from "../../base-app-detail-env.service";
import { Subject } from "rxjs";

@Injectable()
export class BaseSubmenuAutoScalingService {
    private static instance: BaseSubmenuAutoScalingService = null;

    private autoScaleState$: Subject<boolean> = new Subject();

    public static getInstance(http: Http, envCtrlSvc: BaseAppDetailEnvService) {
        if (!BaseSubmenuAutoScalingService.instance) {
            BaseSubmenuAutoScalingService.instance = new BaseSubmenuAutoScalingService(http, envCtrlSvc);
        }
        return BaseSubmenuAutoScalingService.instance;
    }


    private constructor(private http: Http, private envCtrlSvc: BaseAppDetailEnvService) {
    }

    /**
     * The auto-scaling component have two modes: Submenu and AppDetailsHeaderPill
     * When "Submenu" is mounted two instances of the same component would exist, and the
     * pill should be notified when the auto-scale mode change. This subject (autoScaleState$)
     * broadcast the state: Submenu emits "updateState" and AppDetailsHeaderPill catch it
     * by subscribing this subject.
     */
    getAutoScalingStateSubject() {
        return this.autoScaleState$;
    }

    /**
     * Notify both the pill and the submenu about a change.
     * This is how both instances intercommunicate
     */
    updateAutoScalingState(state: boolean) {
        this.autoScaleState$.next(state);
    }

    getEnvCtrlService() {
        return this.envCtrlSvc;
    }
}
